import {ENV, LUONTO, METSAINEN} from '../../constants/'

export default {
    namespaced: true,

    state: {
        env: ENV,
        toolbarHidden: false,
        onlyHidden: false,
        showOnlyHidden: false
    },

    actions: {

        setShowOnlyHidden({commit}, show)
        {
            commit('setShowOnlyHidden', show)
        },


        setToolbarHidden(context, payload)
        {
            context.commit('setToolbarHidden', payload)
        },

        setOnlyHidden(context, payload)
        {
            console.log("setOnlyHidden", payload)
            context.commit('setOnlyHidden', payload)
        }
    },

    mutations: {

        setShowOnlyHidden(state, payload)
        {
            state.showOnlyHidden = payload
        },



        setOnlyHidden(state, payload)
        {
           
           
            state.onlyHidden = payload
            //window.vm.$emit('onlyHiddenChanged')
        },

        setToolbarHidden(state, payload)
        {
            state.toolbarHidden = payload
        }
    },

    getters:{

        showOnlyHidden(state)
        {
            return state.showOnlyHidden
        },


        env(state)
        {
            return state.env;
        },

        isLuonto(state)
        {
            return state.env === LUONTO;
        },

        isMetsainen(state)
        {
            return state.env === METSAINEN;
        },

        toolbarHidden(state)
        {
            return state.toolbarHidden
        },

        onlyHidden(state)
        {
            return state.onlyHidden
        }
    }
}